import { useState } from 'react'
import { createContainer } from 'unstated-next'

export function useViewerMode() {
    const [viewerMode, setViewerMode] = useState(false)
    return { viewerMode, setViewerMode }
}

export default createContainer(useViewerMode)
